import gql from 'graphql-tag';

export default gql`
query productImagesById($ext_id: Int) {
    adminProducts(
        filters: {
            ext_id: $ext_id
        },
        first:1,
        page:1
    ) {
      data {
        id
        ext_id
        images {
          id
          url
          mime_type
          size
          is_default
          conversions {thumbnail list full}
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/api/graphql/queries/productImagesById.ts